module.exports = __webpack_public_path__ + "static/daily-activity-3-a0fa67f9b7e2103dd8c52dcca64e552f.png";